<!--
 * @Author: your name
 * @Date: 2021-08-12 00:20:45
 * @LastEditTime: 2021-08-22 17:34:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/components/OuterRing.vue
-->
<template>
  <div class="full-screen-box">
    <div class="full-screen-container" :style="containerStyle">
      <slot name="title">
        <div class="title-box" :style="titleStyle">
          <span v-if="title" class="top-title">{{ title }}</span>
        </div>
      </slot>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    containerStyle: {
      type: String,
      default: "",
    },
    titleStyle: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="less">
.full-screen-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 30px;
}

.full-screen-container {
  position: relative;
  width: 86%;
  border: 1px solid #f1a705;
  padding: 20px 10px;
  border-radius: 10px;
}

.title-box {
  position: absolute;
  font-size: 16px;
  text-align: center;
  top: -10px;
  left: 0;
  right: 0;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}

.top-title {
  padding: 0 6px;
  font-weight: 600;
  background-color: #fff;
}
</style>
